/* -----------------Globals--------------- */
import {
	Redirect,
	router,
	useLocalSearchParams,
	usePathname,
} from "expo-router";

/* -----------------Child components--------------- */

import { useUser } from "@clerk/clerk-expo";
import DeeplinkProvider from "@contexts/DeeplinkProvider";
import OnboardingAppBar from "@features/auth/components/OnboardingAppBar";
import Landing from "@features/auth/screens/Landing";
import { isWeb } from "@helpers/platform";
import { useAppStore } from "@hooks/useAppStore";
import useBreakpoints from "@hooks/useBreakpoints";
import Box from "@memorang/ui/src/components/Box";
import Loader from "@memorang/ui/src/components/Loader";
import WelcomeFeaturesList, {
	type FeatureProp,
} from "@memorang/ui/src/components/WelcomeFeaturesList";
import DocumentTitle from "components/DocumentTitle";
/* -----------------Helpers & Hooks--------------- */
import { Image } from "expo-image";
import { useWindowDimensions } from "react-native";

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
export default function IndexRoute() {
	const { logo: appLogo, landing } = useAppStore((store) => store.app);
	const { isSignedIn, isLoaded } = useUser();
	const {
		mdUp: isDesktopUp,
		lgUp: isDesktopLargeUp,
		smUp: isTabletUp,
		smDown: isMobileDown,
	} = useBreakpoints();
	const { width } = useWindowDimensions();
	const pathname = usePathname();

	const { auth_token } = useLocalSearchParams<{ auth_token: string }>();

	const isVerify = pathname === "/verify";

	// useEffect(() => {
	// 	trackPageView({ type: pageViewTypes.splash });
	// }, []);

	if (!isLoaded) {
		return <Loader />;
	}
	if (isSignedIn && !isVerify && !auth_token) {
		return <Redirect href="/(protected)/(tabs)/home" />;
	}

	const handleNext = () => {
		router.push("/(auth)/login");
	};

	const isNativeTablet = isTabletUp && !isDesktopLargeUp && !isWeb;
	const showFeatureList =
		landing?.valueProps && isTabletUp && !isDesktopLargeUp && isWeb;
	const showRightPanel =
		isDesktopLargeUp && landing?.landingGraphics && landing?.valueProps;

	return (
		<DeeplinkProvider>
			<DocumentTitle title={"Welcome"} />
			<Box flex={1} flexDirection="row">
				<Box
					flex={1}
					maxWidth={isDesktopLargeUp ? width / 2 : "100%"}
					// backgroundColor={theme.colors.onPrimary}
					paddingBottom={isWeb ? 0 : 24}
					overflow="hidden"
					gap={24}
				>
					{isWeb && (
						<OnboardingAppBar
							showLogo
							style={{ backgroundColor: "transparent" }}
						/>
					)}
					<Box
						paddingHorizontal={24}
						flex={
							isDesktopLargeUp || isMobileDown || isNativeTablet ? 1 : undefined
						}
						style={{
							maxWidth:
								isTabletUp && isWeb ? (isDesktopUp ? 440 : 360) : "100%",
						}}
						alignSelf={isWeb ? "center" : undefined}
						alignItems="center"
						justifyContent="center"
					>
						{!isWeb && (
							<Box
								flex={1}
								alignSelf="flex-end"
								width="100%"
								justifyContent="flex-end"
								alignItems="center"
								padding={24}
							>
								<Image
									source={{ uri: appLogo.stacked.light.uri }}
									style={{ width: 275, height: 152 }}
									contentFit="contain"
								/>
							</Box>
						)}
						<Landing
							appLogo={appLogo}
							handleNext={handleNext}
							valueProps={landing?.valueProps as FeatureProp[]}
							title={
								landing?.title as {
									prefix?: string;
									decoratedText?: string;
									suffix?: string;
								}
							}
							marketText={landing?.marketText}
						/>
					</Box>

					{showFeatureList && (
						<Box
							width="100%"
							justifyContent="center"
							alignItems="center"
							paddingTop={24}
							paddingHorizontal={24}
						>
							<WelcomeFeaturesList
								valueProps={landing?.valueProps as FeatureProp[]}
							/>
						</Box>
					)}
				</Box>

				{showRightPanel && (
					<Box
						flex={1}
						justifyContent="center"
						alignItems="center"
						padding={48}
						minWidth={816}
						maxWidth={width / 2}
						gap={32}
					>
						<Image
							source={{ uri: landing?.landingGraphics ?? "" }}
							style={{
								width: "100%",
								maxWidth: 816,
								aspectRatio: 1.516,
							}}
							contentFit="contain"
						/>
						<WelcomeFeaturesList
							valueProps={landing?.valueProps as FeatureProp[]}
						/>
					</Box>
				)}
			</Box>
		</DeeplinkProvider>
	);
}
